import { AspectRatio, Box, Button, Image, Text } from "@chakra-ui/react";
import React from "react";
import "./Blogs.css";
const Blogs = () => {
  return (
    <Box w={"100%"} textAlign={"left"} p={10}>
      <Text className="oswald-font" fontWeight={"extrabold"} fontSize={34}>
        BLOG
      </Text>
      <Box
        display="grid"
        gridTemplateColumns={{ md: "repeat(3, 1fr)", base: "repeat(1, 1fr)" }}
        gap={5}
      >
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/08/Untitled-2.png"
            borderRadius={20}
            mt={10}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/07/17.jpg"
            borderRadius={20}
            mt={10}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/07/9.jpg"
            borderRadius={20}
            mt={10}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
        {/* second */}
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/08/Untitled-3.png"
            borderRadius={20}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/07/16.jpg"
            borderRadius={20}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/07/8.jpg"
            borderRadius={20}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
        {/* Third */}
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/08/Untitled.png"
            borderRadius={20}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/07/15.jpg"
            borderRadius={20}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
        <Box className="image-container" cursor={"pointer"}>
          <Image
            src="https://wishfy.io/wp-content/uploads/2023/07/7.jpg"
            borderRadius={20}
          />
          <Button
            className="know-more-button"
            color={"white"}
            bg={"#FC1A64"}
            borderRadius={20}
            p={2}
            w={"40%"}
            h={12}
            fontSize={18}
            fontWeight={"bold"}
          >
            Know More
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Blogs;
